"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flip = void 0;
function flip(obj) {
    const obj2 = {};
    Object.keys(obj).forEach(key => {
        obj2[obj[key]] = key;
    });
    return obj2;
}
exports.flip = flip;
//# sourceMappingURL=flip.js.map